angular.module('natgeo').controller('Level3DefineScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'ColorizeFactory', 'SoundEngine', 
function Level3DefineScreen($scope, element, ScreenFactory, manager, container, ColorizeFactory, SoundEngine)
{
	var screen = ScreenFactory( 'level3_define', element );
	
	screen.once('introBefore', function()
	{
		anim8.save('defineBeeContainerIntro', {
			keyframe: {
				from: {
					translate: -25,
					opacity: 0
				},
				to: {
					translate: 0,
					opacity: 1
				}
			}, 
			units: {
				translate: '%'
			}
		});
	});
	
	// The previous screen is the splash screen
	$scope.prev = function()
	{
		manager.transition('level3_splash');
	};
	
	// The next screen is the learn screen
	$scope.next = function()
	{
		manager.transition('level3_learn');
	};
	
}]);